import type { MdDrafDiff } from "@/types";
import { createPatch, diffLines, diffChars } from "diff";

// function generateDiffPatch(text1: string, text2: string) {
//   // 计算文本之间的差异（按行计算）
//   const diffs = diffChars(text1, text2);
//   console.log("diffs", diffs);
//   const charPatch = [] as MdDrafDiff[];
//   let startIndex = 0,
//     endIndex = 0;
//   let diffContent = "";
//   let isClearPart = true;
//   diffs.forEach((part) => {
//     if (part.removed) {
//       isClearPart = false;
//       endIndex += part.count || 0;
//     } else if (part.added) {
//       isClearPart = false;
//       diffContent = part.value;
//     } else {
//       // 到达统一位置以上完成一个块修改
//       if (!isClearPart) {
//         charPatch.push({
//           start: startIndex,
//           end: endIndex,
//           diffContent: diffContent,
//         });
//       }
//       isClearPart = true;
//       endIndex += part.count || 0;
//       startIndex = endIndex;
//       diffContent = "";
//     }
//   });
//   if (!isClearPart) {
//     // 处理在added和removed均为false的情况后的最后一块差异
//     charPatch.push({
//       start: startIndex,
//       end: endIndex,
//       diffContent: diffContent,
//     });
//   }
//   return charPatch;
// }

function generateDiffPatch(text1: string, text2: string) {
  const diffs = diffChars(text1, text2);
  const charPatch: MdDrafDiff[] = [];

  let cursor = 0; // 追踪当前在原始文本的位置
  diffs.forEach((part) => {
    if (part.removed) {
      const start = cursor;
      const end = cursor + (part.count || part.value.length);
      charPatch.push({ start, end, diffContent: "" });
      cursor = end;
    } else if (part.added) {
      // 插入是相对于当前 cursor 插入
      charPatch.push({ start: cursor, end: cursor, diffContent: part.value });
    } else {
      cursor += part.count || part.value.length;
    }
  });

  return charPatch;
}

export { generateDiffPatch };
